import { render, staticRenderFns } from "./VertragAbschriftModal.vue?vue&type=template&id=519ef966&"
import script from "./VertragAbschriftModal.vue?vue&type=script&lang=js&"
export * from "./VertragAbschriftModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports